import * as types from '../mutation-types';
import {
    get_locations,
    get_restaurant,
    get_hotel
} from '@/api/location';

export const state = {
    locations: [],
    loading: false,
    loading_hotel: false,
    restaurant: {
        available_action: {
            take_away: false,
            walk_in: false,
            hotel_guest: false,
            delivery: false
        },
        province: {
            slug: null,
            name: null
        }
    },
    hotel: {
        restaurants: [],
        spas: [],
        shops: []
    }

}
export const getters = {
    locations: state => state.locations,
    restaurant: state => state.restaurant,
    hotel: state => state.hotel,
    loading: state => state.loading,
    loading_hotel: state => state.loading_hotel
}
export const mutations = {
    [types.LOCATION](state, payload) {
        state.loading = true;
    },
    [types.LOCATION_FAIL](state, payload) {
        state.loading = false;
        state.locations = [];
    },
    [types.LOCATION_SUCCESS](state, payload) {
        state.loading = false;
        state.locations = payload.data;

    },

    [types.RESTAURANT](state, payload) {
        state.loading = true;
    },
    [types.RESTAURANT_FAIL](state, payload) {
        state.loading = false;
        state.restaurant = {
            available_action: {
                take_away: false,
                walk_in: false,
                hotel_guest: false,
                delivery: false
            }
        };
    },
    [types.RESTAURANT_SUCCESS](state, payload) {
        state.loading = false;
        state.restaurant = payload.data;

    },

    [types.HOTEL](state, payload) {
        state.loading_hotel = true;
    },
    [types.HOTEL_FAIL](state, payload) {
        state.loading_hotel = false;
        state.hotel = {
        };
    },
    [types.HOTEL_SUCCESS](state, payload) {
        state.loading_hotel = false;
        state.hotel = payload.data;

    },

}
export const actions = {

    async getLocations({
        commit,
        getters
    }, payload) {
        commit(types.LOCATION);
        try {
            const data = await get_locations(payload);
            commit(types.LOCATION_SUCCESS, data);
        } catch (error) {
            console.log(error)
            commit(types.LOCATION_FAIL);
        }
    },
    async get_restaurant({
        commit,
        getters
    }, payload) {
        commit(types.RESTAURANT);
        try {
            const data = await get_restaurant(payload);
            commit(types.RESTAURANT_SUCCESS, data);
        } catch (error) {
            commit(types.RESTAURANT_FAIL);
        }
    },
    async getHotel({
        commit,
        getters
    }, payload) {
        commit(types.HOTEL);
        try {
            const data = await get_hotel(payload);
            commit(types.HOTEL_SUCCESS, data);
        } catch (error) {
            commit(types.HOTEL_FAIL);
        }
    },
}